/**
 * formatTimeAgo — render an ISO-8601 timestamp as a compact relative-time
 * string (e.g. "14h ago", "3m ago", "2d ago").
 *
 * Used by ParityAudit and ProficiencyWatch observability footers to give
 * operators a single-glance read on whether nightly background jobs
 * are firing. Returns an empty string for null/invalid inputs so the
 * caller can render unconditionally without guard clauses.
 *
 * Introduced in v6.36.31 (was previously inlined in ParityAudit.js).
 */
export const formatTimeAgo = (iso) => {
  if (!iso) return '';
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return '';
  const sec = Math.max(0, Math.floor((Date.now() - t) / 1000));
  if (sec < 60) return `${sec}s ago`;
  if (sec < 3600) return `${Math.floor(sec / 60)}m ago`;
  if (sec < 86400) return `${Math.floor(sec / 3600)}h ago`;
  return `${Math.floor(sec / 86400)}d ago`;
};

export default formatTimeAgo;
